import { useEffect, useState } from 'react';
import { AUTH_TOKEN_STORAGE_KEY, TOKEN_READY_EVENT } from '@constants/auth';

type UseToken = string | undefined | null;

/**
 * Reads the current access token. Seeds from sessionStorage on mount (set by
 * TokenBridge) and stays in sync via the `tokenReady` event — including token
 * renewals and sign-out (empty token → null). Reader only; TokenBridge owns
 * writing sessionStorage.
 */
const useToken = (): UseToken => {
	const [token, setToken] = useState<UseToken>(() =>
		sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY)
	);

	useEffect(() => {
		const handleTokenReady = (event: WindowEventMap['tokenReady']): void => {
			setToken(event.detail.token || null);
		};

		window.addEventListener(TOKEN_READY_EVENT, handleTokenReady);

		return () => {
			window.removeEventListener(TOKEN_READY_EVENT, handleTokenReady);
		};
	}, []);

	return token;
};

export default useToken;
